/* eslint-disable */
export enum ItonicsApp {
  INSIGHTS = 'insights',
  EXPLORER = 'explorer',
  ROADMAP = 'roadmap',
  SETTINGS = 'settings',
  SUITE = 'suite',
  ID = 'id',
  EMBEDDABLE = 'embed',
  CLIPPINGS = 'clippings',
  EXTERNAL_REPORTS = 'external-reports'
}
